import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Anchor } from 'antd';
import { Button, Layout, Text, Space } from '@/components/atoms';
import { PATH_MAIN, API_AUTH_LOGIN, API_AUTH_SIGNUP } from '@/constants/constant';
import logoBlack from '@images/common/logo-bizcenter-main.png';
import logoWhite from '@images/common/logo_white.png';

export type LandingHeaderProps = {
  user?: any;
  logout?: () => void;
  layoutFixed: boolean;
  mode: 'dark' | 'light';
  gnbList?: any[];
};

const LandingHeader = ({ user, logout, layoutFixed, mode, gnbList }: LandingHeaderProps) => {
  // gnb 메뉴 정의
  gnbList = [
    // {
    //   menuName: '핀카알림',
    //   url: `${PATH_MAIN}#alarm`,
    //   class: 'gnb-alarm',
    // },
    // {
    //   menuName: '민원대행',
    //   url: `${PATH_MAIN}#mimwon`,
    //   class: 'gnb-minwow',
    // },
    {
      menuName: '렌터카 ERP',
      url: `${PATH_MAIN}#erp`,
      class: '',
    },
    {
      menuName: '차량거래',
      url: `${PATH_MAIN}#contract`,
      class: 'gnb-contract',
    },
  ];
  // 모바일 gnb메뉴 열기
  const [gnb, setGnb] = useState(false);
  const menuToggle = () => {
    setGnb(!gnb);
  };

  // 로그인, 회원가입 링크
  const unsignedRow = (
    <Space direction="horizontal" className="link-wrapper">
      <Link className="link" to={API_AUTH_LOGIN}>
        로그인
      </Link>
      <Text className="link">/</Text>
      <Link className="link" to={API_AUTH_SIGNUP}>
        회원가입
      </Link>
    </Space>
  );
  // 로그아웃 버튼
  const signedRow = (
    <Space direction="horizontal" className="link-wrapper">
      <Link className="link" to="/manage">
        <span className="user-name">{user?.name}님</span>
      </Link>
      <Button type="text" onClick={logout}>
        로그아웃
      </Button>
    </Space>
  );
  // 모바일 햄버거메뉴 버튼
  const openMenu = (
    <Button type="ghost" onClick={menuToggle} className="btn-mobile open-gnb" title="모바일메뉴열기">
      <span className="menu-ber" />
      <span className="menu-ber" />
      <span className="menu-ber" />
      <span className="menu-ber" />
    </Button>
  );
  const closeMenu = (
    <Button type="ghost" onClick={menuToggle} className="btn-mobile close-gnb">
      모바일 메뉴 닫기
    </Button>
  );

  return (
    <>
      <Layout className={layoutFixed ? 'landing-header-wrap header--fixed' : 'landing-header-wrap'}>
        <div className={gnb ? 'bg-gnb show' : 'bg-gnb'} />
        <header className={mode === 'dark' ? 'landing-header' : 'landing-header landing-header-light'}>
          <Anchor affix={false}>
            <h1 className="logo">
              <Anchor.Link
                href={`${PATH_MAIN}#initial`}
                className="font-bold"
                title={<img src={mode === 'dark' ? logoWhite : logoBlack} alt="핀카비즈센터 로고이미지" />}
              />
            </h1>
          </Anchor>
          {openMenu}
          <Space className={gnb ? 'landing-gnb-wrap show' : 'landing-gnb-wrap'}>
            <Anchor affix={false} className="landing-gnb-list">
              {gnbList.map((menuList) => (
                <Anchor.Link key={menuList.index} href={menuList.url} title={menuList.menuName} className={`gnb-link ${menuList.class}`} />
              ))}
            </Anchor>
            {/* {user ? signedRow : unsignedRow} */}
            {closeMenu}
          </Space>
        </header>
      </Layout>
    </>
  );
};

LandingHeader.defaultProps = {
  user: undefined,
  layoutFixed: true,
  mode: 'dark',
};

export default LandingHeader;
